import { Dataset } from "@rezonence/core";
import { DemoType } from "./DemoType";
import { previewFolder } from "./preview.folder";

export const recordFolderByDemoType: Record<DemoType, string> = {
  [DemoType.Preview]: previewFolder,
  [DemoType.Shared]: Dataset.Freewall
};
